// Файл consent_storage.js

/**
 * Модуль обслуживает сценарий `consent_storage` в разделе
 * `page_authorization`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

import { storage } from '../utils/storage';



// Хранение и проверка согласий в localStorage,
// а также запись cookie-согласия на сервер

import { apiService } from '../services/api.js';



const COOKIE_STORAGE_KEY = 'cookie_consent_v1';
const PD_STORAGE_KEY = 'pd_consent_v1';
const POLICY_VERSION = '1.0';
const REMINDER_DAYS = 30;

const read_consent = (storage_key) => {
    try {
        const raw = storage.get_item(
            storage_key);

        if (!raw)
            return null;
        
        return JSON.parse(raw);

    } catch {
        return null;
    }
};

const is_consent_still_valid = (storage_key) => {
    const data = read_consent(storage_key);
    
    if (!data)
        return false;
    
    if (data.consent !== 'accepted')
        return false;
    
    if (data.version !== POLICY_VERSION)
        return false;

    const accepted_at = new Date(data.acceptedAt);
    if (Number.isNaN(accepted_at.getTime()))
        return false;

    const expires_at = new Date(accepted_at);
    expires_at.setDate(
        expires_at.getDate() + REMINDER_DAYS);

    return new Date() < expires_at;
};

const clear_consent = (storage_key) => {
    try {
        storage.removeState(storage_key);

    } catch {
        return;
    }
};

const save_cookie_consent_accepted = () => {
    const payload = {
        consent: 'accepted',
        version: POLICY_VERSION,
        acceptedAt: new Date().toISOString(),
    };

    try {
        storage.set_item(
            COOKIE_STORAGE_KEY,
            JSON.stringify(payload)
        );

    } catch {
        return;
    }

    apiService.df({
        table_name: 'log_cookie_consent',
        params: payload,
    }).catch(() => {});
};


export {
    COOKIE_STORAGE_KEY,
    PD_STORAGE_KEY,
    POLICY_VERSION,
    REMINDER_DAYS,
    read_consent,
    is_consent_still_valid,
    clear_consent,
    save_cookie_consent_accepted,
};
